export const en = {
  // Navigation
  nav: {
    home: 'Home',
    search: 'Search',
    inspirations: 'Inspirations',
    about: 'About',
    favorites: 'Favorites',
    login: 'Login',
    advisor: 'Advisor',
    speakToAdvisor: 'Speak to an Advisor'
  },

  // Homepage
  homepage: {
    heroTitle: 'PRIVIA',
    heroSubtitle: 'The visual embodiment of the most refined emotions',
    heroDescription: 'We don\'t just show villas, we make you feel a way of life',
    heroExperiences: 'Exclusive Experiences',
    discoverVillas: 'Discover our Villas',
    speakToConcierge: 'Speak to our Concierge',
    
    // Destinations section
    destinationsTitle: 'Our Exceptional Destinations',
    destinationsSubtitle: 'Carefully selected places of exception where luxury meets authenticity, for unforgettable experiences around the world.',
    destinationsStats: 'destinations • 200+ exceptional villas',
    allRegions: 'All Regions',
    
    // Villa search section
    findEmotion: 'Find Your Emotion',
    findEmotionSubtitle: 'Each villa tells a story, evokes a unique emotion. Let yourself be guided by your feelings.',
    searchPlaceholder: 'Search by destination, emotion...',
    
    // Villas section
    villasTitle: 'Our Exceptional Villas',
    villasSubtitle: 'Each property is selected for its ability to awaken deep emotions and create unforgettable memories.',
    villasForEmotion: 'villa(s) for your emotion',
    noVillasFound: 'No villas found for this search',
    resetFilters: 'Reset filters',
    
    // Social proof
    excellenceTitle: 'Recognized Excellence',
    prestigePartners: 'Prestige Partners',
    
    // Stats
    stats: {
      villas: 'Exceptional Villas',
      destinations: 'Destinations',
      satisfaction: 'Customer Satisfaction',
      service: 'Concierge Service'
    },
    
    // Footer
    footer: {
      tagline: 'The art of living at its peak',
      copyright: '© 2024 PRIVIA. All rights reserved.',
      legal: 'Legal Notice',
      gdpr: 'GDPR',
      madeWith: 'Made with',
      in: 'in Paris'
    }
  },

  // Emotions
  emotions: {
    serenity: {
      label: 'Pure Serenity',
      description: 'Breathing slows down, shoulders relax'
    },
    privilege: {
      label: 'Discreet Privilege',
      description: 'Feeling of belonging to a secret circle'
    },
    anticipation: {
      label: 'Magical Anticipation',
      description: 'Thrill of excitement, heart gently accelerating'
    },
    intimacy: {
      label: 'Sophisticated Intimacy',
      description: 'Enveloping warmth, luxurious cocoon'
    },
    freedom: {
      label: 'Infinite Freedom',
      description: 'Breathtaking view of the horizon'
    },
    allEmotions: 'All Emotions'
  },

  // Villa details
  villa: {
    backToVillas: 'Back to villas',
    bookNow: 'Book Now',
    checkAvailability: 'Check Availability',
    story: 'The Story of this Villa',
    pricingSeasons: 'Seasonal Pricing',
    signatureExperiences: 'Signature Experiences',
    exceptionalAmenities: 'Exceptional Amenities',
    includedServices: 'Included Services',
    location: 'Location',
    characteristics: 'Characteristics',
    livingSpace: 'Living space',
    grounds: 'Grounds',
    capacity: 'Capacity',
    bedrooms: 'Bedrooms',
    bathrooms: 'Bathrooms',
    coordinates: 'Coordinates',
    pointsOfInterest: 'Points of interest',
    bookVilla: 'Book {villaName}',
    pricingPeriod: 'Pricing period',
    arrival: 'Arrival',
    departure: 'Departure',
    guests: 'Number of guests',
    person: 'person',
    people: 'people',
    nights: 'nights',
    includedServices: 'Included services',
    included: 'Included',
    total: 'Total',
    confirmBooking: 'Confirm Booking',
    gallery: 'Gallery',
    callNow: 'Call now',
    privateMessage: 'Private message'
  },

  // Search page
  search: {
    destination: 'Destination',
    allDestinations: 'All destinations',
    arrival: 'Arrival',
    departure: 'Departure',
    travelers: 'Travelers',
    filters: 'Filters',
    budget: 'Budget (€/week)',
    min: 'Min',
    max: 'Max',
    minBedrooms: 'Min. bedrooms',
    indifferent: 'Indifferent',
    bedroom: 'bedroom',
    bedrooms: 'bedrooms',
    clearFilters: 'Clear filters',
    filterByEmotion: 'Filter by emotion',
    villasIn: 'Villas in {destination}',
    villaSearch: 'Villa Search',
    available: 'available for your dates',
    relevance: 'Relevance',
    priceAsc: 'Price ascending',
    priceDesc: 'Price descending',
    nameAZ: 'Name A-Z',
    noVillasFound: 'No villas found',
    tryModifying: 'Try modifying your search criteria or explore our popular destinations',
    resetSearch: 'Reset search'
  },

  // Inspirations page
  inspirations: {
    title: 'Don\'t know where to go?',
    subtitle: 'Let yourself be inspired by our thematic collections and discover your next dream destination',
    exploreCollections: 'Explore Collections',
    allInspirations: 'All inspirations',
    seasons: 'Seasons',
    family: 'Family',
    romantic: 'Romantic',
    adventure: 'Adventure',
    wellness: 'Wellness',
    collectionsTitle: 'Inspiration Collections',
    collectionsSubtitle: 'Each collection tells a story, evokes an emotion and guides you to the perfect experience',
    destinations: 'destinations',
    villas: 'villas',
    exploreCollection: 'Explore this collection',
    personalizedTitle: 'Your Personalized Inspiration',
    personalizedSubtitle: 'Our advisors create tailor-made experiences according to your passions and dreams',
    speakToAdvisor: 'Speak to an Advisor'
  },

  // About page
  about: {
    title: 'The Art of Living Reinvented',
    subtitle: 'Since 2014, PRIVIA has been revolutionizing the luxury travel experience by creating emotional bridges between our clients and the world\'s most beautiful homes',
    ourStory: 'Our Story',
    mission: 'Our Mission',
    missionTitle: 'Creating Authentic Emotions',
    missionText1: 'At PRIVIA, we believe that every journey should be a renaissance. Our mission transcends simple villa rental: we create experiences that mark a lifetime, memories that become treasures.',
    missionText2: 'Our unique emotional approach allows us to guide you to the villa that will resonate perfectly with your deepest aspirations, creating perfect harmony between the place and your state of mind.',
    discoverCollection: 'Discover our Collection',
    excellence: 'Excellence',
    excellenceDescription: 'Our signature in every detail of your experience',
    foundingValues: 'Founding Values',
    foundingValuesSubtitle: 'Four pillars guide each of our actions and shape the PRIVIA experience',
    passionForBeauty: 'Passion for Beauty',
    passionDescription: 'We select each villa with the same care that a collector chooses a work of art.',
    serviceExcellence: 'Service Excellence',
    serviceDescription: 'Our 24/7 concierge anticipates your needs to transform each stay into an unforgettable experience.',
    authenticity: 'Authenticity',
    authenticityDescription: 'Each destination reveals its best-kept secrets thanks to our privileged local network.',
    emotionalInnovation: 'Emotional Innovation',
    innovationDescription: 'Our unique emotional approach guides you to the villa that will resonate with your soul.',
    priviaInNumbers: 'PRIVIA in Numbers',
    numbersSubtitle: 'A decade of excellence in service of your escape dreams',
    team: 'The PRIVIA Team',
    teamSubtitle: 'Passionate people in service of your most precious emotions',
    readyToExperience: 'Ready to Experience PRIVIA?',
    advisorsReady: 'Our advisors are listening to create your tailor-made journey',
    planCall: 'Plan a Call',
    contactUs: 'Contact Us'
  },

  // Common
  common: {
    loading: 'Loading...',
    error: 'An error occurred',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    edit: 'Edit',
    delete: 'Delete',
    previous: 'Previous',
    next: 'Next',
    viewMore: 'View more',
    viewLess: 'View less',
    explore: 'Explore',
    discover: 'Discover',
    book: 'Book',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    website: 'Website',
    socialMedia: 'Social Media',
    followUs: 'Follow us',
    newsletter: 'Newsletter',
    subscribe: 'Subscribe',
    unsubscribe: 'Unsubscribe',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy'
  },

  // Regions
  regions: {
    caribbean: {
      name: 'Caribbean',
      description: 'Exceptional tropical paradise'
    },
    frenchRiviera: {
      name: 'French Riviera',
      description: 'The French art of living'
    },
    corsica: {
      name: 'Corsica',
      description: 'The authentic island of beauty'
    },
    monaco: {
      name: 'Monaco',
      description: 'Principality of absolute luxury'
    },
    italy: {
      name: 'Italy',
      description: 'Mediterranean dolce vita'
    },
    greece: {
      name: 'Greece',
      description: 'Aegean mythology and splendor'
    },
    spain: {
      name: 'Spain',
      description: 'Refined Iberian passion'
    }
  }
};